import { LoanRequest_ApplicantCreated } from 'cpool-events';
import { Personendaten, schemaId } from 'cpool-schemas';
import { z } from 'zod';

const PersonendatenReadModel = Personendaten.extend({
    telefonPrivatE164: z.string().nullable(),
});

export const ApplicantsTableDefinitionZod = LoanRequest_ApplicantCreated.prototype.getSchema().merge(
    z.object({
        applicantHash: z.string().nullable(),
        isCensored: z.boolean().default(false),
        leadId: schemaId,
        meta: z
            .object({
                applicantEmailVerification: z
                    .object({
                        correlationId: schemaId.nullable(),
                        sentAt: z.number().nullable(),
                    })
                    .default({ correlationId: null, sentAt: null }),
            })
            .default({ applicantEmailVerification: { correlationId: null, sentAt: null } }),
        personendaten: PersonendatenReadModel,
    }),
);

export type ApplicantsTableSchema = z.infer<typeof ApplicantsTableDefinitionZod>;
